import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const list_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M9.002,5.5 L19.002,5.5 M4.0005,5.5 L6.0005,5.5 M9.002,9.5
      L19.002,9.5 M4.0005,9.5 L6.0005,9.5 M9.002,17.5 L19.002,17.5 M4.0005,17.5 L6.0005,17.5
      M9.002,13.5 L19.002,13.5 M4.0005,13.5 L6.0005,13.5"
      />
    </svg>
  );
};
